var type;
var PTypeId,PGroupId,MConfId,MTypeId;
var flag;
$(document).ready(function(){
	
	$("#mesurementButton").click(function(){
      	$("#measurement").modal('show');
		openMesurement();
	});
	
	$("#measurement #measurement-next-button").click(function(){
		var profileId = $(".featherlight #measurement #Profile").find(":selected").attr("value");
		var profileName = $(".featherlight #measurement #Profile").find(":selected").text();
		var IsActive = true;//$(".featherlight #measurement #Customer").find(":selected").hasClass("active");
		//swal(profileId);
		$.ajax({
			url : "Code/mylook.php?getCustProfileValues",
			method : "POST",
			dataType : "json",
			data : {
				profileId : profileId
			}
		}).done(function(r){
			//console.log("length : "+r.length);
			
			if(r.length <= 0){
				$(".featherlight").css("z-index","1059");
				swal({showCloseButton:true,title:'Oops...',text:'Selected profile is empty..',type:'error'});
				return;
			}
			
			var txt = "<tbody><tr><td></td><td>Centimeter</td><td>Inches</td></tr>";
			$.each(r,function(index,value){
				txt += "<tr>";
				txt += "<td>"+value['ParameterName']+"</td>";
				txt += "<td><input disabled type='text' pid='"+value['ParameterId']+"' class='val' value='"+value['ParameterValue']+"'></td>"; 
				txt += "<td><input disabled type='text' value='"+toInch(value['ParameterValue'])+"'></td>";
				txt += "</tr>";
			});
			if(IsActive){
				txt += "<tr><td><input type='button'  style='background-color:#999966' value='Back'></td>";
				txt += "<td><input upi='"+r[0]['UProfileId']+"' tid='"+MTypeId+"' s='"+r[0]['MSizeName']+"' type='button'  style='background-color:#999966' value='Edit'></td>";
				txt += "<td><input type='button'  style='background-color:#999966' value='Close'></td></tr></tbody>";
			}else{
				txt += "<tr><td></td><td><input type='button'  style='background-color:#999966' value='Back'></td>";
				txt += "<td><input type='button'  style='background-color:#999966' value='Close'></td></tr></tbody>";
			}
			$.featherlight($('#measurement-size'), {
				beforeOpen: function() { 
					$.featherlight.close(); 
				}
			});
			$(".featherlight").find("table").empty();
			$(".featherlight #measurement-details").html("<h3><span>"+profileName+"</span>("+r[0]['MSizeName']+")</h3>");
			$(".featherlight").find("table").html(txt);
			setTableButtonClickEvent();
		}).fail(function(xhr,status){
			//swal(status,"error");
		});
	});
	
	$("#logout").click(function(){
		$.ajax({
			url : "Code/mylook.php?logout",
			method : "POST"
		}).done(function(r){
			if(r == true || r == "1"){
				$("#loginstatus").empty().html('<a data-featherlight="#login" href="#">Login</a>');
				swal({showCloseButton:true,title:'Logout...',text:'Successfully',type:'success'});
			}else{
				swal({showCloseButton:true,title:'Oops...',text:'Something Wrong..',type:'error'});
			}
		}).fail(function(xhr,status){
			swal(status,"error");
		});
	});
	$("#measurement #customizeMeasurment").click(function(){
		$.ajax({
			url : "Code/mylook.php?loginCheck",
			method : "POST",
			dataType : "json"
		}).done(function(r){
			if(r == "0" || r == 0){
				$.featherlight($('#login'), {
					beforeOpen: function() { 
						$.featherlight.close(); 
					},
					afterOpen : function(){
						sessionStorage.setItem("IsMesurment",true);
					}
				});
			}else{
				var t,count=0;
				$.each(type,function(index,value){
					if(value['HexValue'].toLowerCase() == $("#Men .active").attr("hex").toLowerCase()){
						//swal(value['TypeName'].toLowerCase(),success);
						count++;
						t = value;
					}
				});
				if(count > 0){
					profileOpen(t);
				}else{
					$(".featherlight").css("z-index","1059");
					swal({showCloseButton:true,title:"Oops...",text:"Measurement are not added",type:"error"});
				}
				//saveProfile(SaveProfile);
			}
		}).fail(function(xhr,status){
			swal(status,"error");
		});
	});
	$("#changePassword").click(function(){
		
		var email = $(".featherlight .login").find("ul li [name=femail]").val();
		var password = $(".featherlight .login").find("ul li [name=fpassword]").val();
		var cpassword = $(".featherlight .login").find("ul li [name=fcpassword]").val();
		
		if(email == undefined || email == ""){
			$(".featherlight").css("z-index","1059");
			swal({showCloseButton:true,title:"Oops...",text:"Please Enter EmailId",type:"error"});
		}else if((password == undefined || password == "") && (cpassword == undefined || cpassword == "")){
			$(".featherlight").css("z-index","1059");
			swal({showCloseButton:true,title:"Oops...",text:"Please Enter Password",type:"error"});
		}else if( password != cpassword){
			$(".featherlight").css("z-index","1059");
			swal({showCloseButton:true,title:"Oops...",text:"Password Does Not Match",type:"error"});
		}else{
			$.ajax({
			url : "Code/mylook.php?forgotPassword",
			method : "POST",
			dataType : "json",
			data : {
				email : email,
				password : password
			}
			}).done(function(r){
				//console.log(r);
				if(r == true || r == "true"){
					$.featherlight.close(); 
					$.featherlight.close();
					swal({showCloseButton:true,title:'Congratulations...',text:'Your password is change',type:'success'});
				}else{
					swal({showCloseButton:true,title:'Oops...',text:'Something Wrong..',type:'error'});
				}
			}).fail(function(xhr,status){
				swal(status,"error");
			});
		}
	});
	
	$("#registration input").blur(function(){
		//console.log("Name : " + $(this).attr('name') + " Value : " + $(this).val());
		var passwordv,cpasswordv;
		if($(this).val() == ""){
			if(!$(this).siblings('span').hasClass('em'))
				$(this).parent().append("<span class='em' style='color:red'> * field is required</span>");
		}else{
			$(this).siblings("span").remove();
			var elementName = $(this).attr('name').toLowerCase();
			switch(elementName){
				
				case 'email':
					var emailv = ValidateEmail($(this).val());
					if(!emailv){
						if(!$(this).siblings('span').hasClass('ve')){
							$(this).parent().append("<span class='ve' style='color:red'> * enter valid  email address</span>");
							//$("#registerbtn").attr('disabled','disabled');
						}
					}else{
						$(this).siblings("span").remove();
						//$("#registerbtn").removeAttr('disabled');
					}
					break;
					
				case 'password' : 
					var passwordv = $(this).val();
					$("#hpassword").val(passwordv);
					if(cpasswordv != undefined && cpasswordv != "")
						if($("#hcpassword").val() != passwordv){
							if(!$(this).parent().siblings('li').find('[name=cpassword] span').hasClass('pd')){
								$(this).parent().siblings('li').find('[name=cpassword]').parent().append("<span class='pd' style='color:red'> * password does not match</span>");
								//$("#registerbtn").attr('disabled','disabled');
							}
						}else{
							$(this).parent().siblings('li').find('.pd').remove();
							//$("#registerbtn").removeAttr('disabled');
						}
					break;
					
				case 'cpassword':
					cpasswordv = $(this).val();
					$("#hcpassword").val(cpasswordv);
					if(cpasswordv != $("#hpassword").val()){
						if(!$(this).siblings('span').hasClass('pd')){
							$(this).parent().append("<span class='pd' style='color:red'> * password does not match</span>");
							//$("#registerbtn").attr('disabled','disabled');
						}
					}else{
						$(this).siblings("span").remove();
						//$("#registerbtn").removeAttr('disabled');
					}
					break;
			}
		}
	});
	
	$("#measurement #measurement-delete-button").click(function(){
		var ProfileId = $("#measurement #Profile").find(":selected").val();
		if(ProfileId != undefined){
			$(".featherlight").css("z-index","1059");
			
			swal({
				title: "Are you sure?",
				text: "You want to delete profile!",
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: '#DD6B55',
				confirmButtonText: 'Yes, I am sure!',
				cancelButtonText: "No, cancel it!",
				closeOnConfirm: false,
				closeOnCancel: false
			}).then(function () {
			  delProfile(ProfileId);
			}, function (dismiss) {
			  
			  if (dismiss === 'cancel') {
				swal(
				  'Cancelled',
				  'Your profile is safe',
				  'error'
				)
			  }
			});
		}else{
			$(".featherlight").css("z-index","1059");
			swal({showCloseButton:true,title:"Oops...",text:"Please select Profile",type:"error"});
		}
	});
 
	//$(".featherlight .val").eq(0).parent("td").siblings().html()
});

      //---------------//
     // * Functions * //
	//---------------//
	
function profile(){
	if(PTypeId != undefined && PGroupId != undefined){
		$.ajax({
		url : "Code/mylook.php?getCustomerProfile",
		method : "POST",
		dataType : "json",
		data : {
			gid : PGroupId,
			pid : PTypeId
		}
		}).done(function(r){
			var txt = "";
			$.each(r,function(index,value){
				txt += "<option value="+value['ProfileId']+">"+value['ProfileName']+"</option>"; 
			});
			$.featherlight($('#measurement'), {
				beforeOpen: function() { 
				$.featherlight.close();
				setAllCustomerClickEvent();
				}
			});
			$(".featherlight").find("#Profile").empty();
			$(".featherlight").find("#Profile").html(txt);
		}).fail(function(xhr,status){
			swal(status,"error");
		});
	}else{
		$.featherlight($('#measurement'), {
			beforeOpen: function() { 
			$.featherlight.close();
			setAllCustomerClickEvent();
			}
		});
	}
}
function setTableButtonClickEvent(){
	$(".featherlight table input").click(function(){
		var value = $(this).attr("value");
		//swal($(this).attr("value"));
		if(value.toLowerCase() == "back"){
			$.featherlight($('#measurement'), {
				beforeOpen: function() { 
					$.featherlight.close(); 
				}
			});
			profile();
		}
		if(value.toLowerCase() == "close"){
			$.featherlight.close(); 
		}
		if(value.toLowerCase() == "edit"){
			
			var profileName = $(".featherlight #measurement-details h3 span").text();
			var userProfileId = $(this).attr("upi");
			var tid = $(this).attr("tid");
			var s = $(this).attr("s").toLowerCase();
			var parameters = new Object;
			for(var i = 0 ; i < $(".featherlight .val").length ; i++){
				parameters[$(".featherlight .val").eq(i).attr("pid")] = $(".featherlight .val").eq(i).val();
			}
			//console.log(parameters);
			$.ajax({
				url : "Code/mylook.php?getMeasurementParameter",
				method : "POST",
				dataType : "json",
				data : {
					tid : tid
				}
			}).done(function(r){
				var productType = 0;
				var productGroupId = 0;
				var type = 0;
				var size = "";
				$.each(r['Size'],function(index,value){
					if(s == value['SizeName'].toLowerCase())
						size += "<option tid='"+tid+"' upi='"+userProfileId+"' tag='edit' value='"+value['MSizeId']+"' selected>"+value['SizeName']+"</option>";
					else
						size += "<option tid='"+tid+"' upi='"+userProfileId+"' tag='edit' value='"+value['MSizeId']+"'>"+value['SizeName']+"</option>"; 
				});
				
				var count = 0;
				var txt = "<tbody><tr><td><b>Parameter</b></td><td><b>Values</b></td></tr>";
				$.each(r['Parameter'],function(index,value){
					txt += "<tr>";
					txt += "<td id='"+value['MParameterId']+"'>"+value['MParameterName']+"</td>";
					count = 0;
					$.each(parameters,function(index2,value2){
						if(index2 == value['MParameterId']){
							txt += "<td><input IsAdded='false' step='.01' type='number' class='val' value='"+value2+"'></td>";
							count++;
						}
					});
					if(count == 0)
						txt += "<td><input IsAdded='true' type='number' value='0' class='val'></td>";
					txt += "<td class='unit'><b>cm</b></td>";
					txt += "</tr>";
				});
				
				// txt += "<tr style='visibility:hidden'>";
				// txt += "<td><input  type='number' value='"+productType+"'  name='gid'></td>";
				// txt += "<td><input  type='number' value='"+productGroupId+"'  name='pid'></td>"; 
				// txt += "<td class='unit'><b>cm</b></td>";
				// txt += "</tr>";
				
				txt +="<tr><td colspan=2><b>Profile Name : </b><input id='profileName' type='text' value='"+profileName+"'></td></tr>";
				txt += "<tr><td><input type='button'  style='background-color:#999966' value='Back'></td>";
				txt += "<td><input id='updateProfile' upi='"+userProfileId+"' pid='"+productType+"' gid='"+productGroupId+"' tid='"+type+"' type='button'  style='background-color:#999966' value='Update'></td></tr></tbody>";
				
				
				$.featherlight($('#saveMeasurement'), {
					beforeOpen: function() { 
						$.featherlight.close(); 
					}
				});
				$(".featherlight #ms").empty().html(size);
				//$(".featherlight #ms").prop('disabled', true);
				//$(".featherlight #mi").prop('disabled', true);
				$(".featherlight").find("table").empty();
				$(".featherlight").find("table").html(txt);
				setTableButtonClickEvent();
				setSaveMeasurementClickEvent();
			}).fail(function(xhr,status){
				swal(status,"error");
			});
			// $.featherlight($('#measurement'), {
				// beforeOpen: function() { 
					// $.featherlight.close(); 
				// }
			// });
		}
	});
	
	$(".featherlight table #profileName").keyup(function(){
		var value = $(this).val();
		$.ajax({
			url : "Code/mylook.php?profileNameCheck",
			method : "POST",
			dataType : "json",
			data : {
				profileName : value
			}
		}).done(function(r){
			//console.log(r);
			if(r){
				$(".featherlight table #namecheck").empty().html("Name already in use..");
				flag = false;
			}else{
				$(".featherlight table #namecheck").empty();
				flag = true;
			}
		}).fail(function(xhr,status){
			swal(status,"error");
		});
	});
}
function setAllCustomerClickEvent(){
	$("#Customer").change(function(){
		var id = $(this).find('option:selected').attr("value");
		var that = this.find('option:selected');
		//swal($(this).parents(".form-group").siblings().find("#Profile").html());
		
		$.ajax({
			url : "Code/mylook.php?getCustProfile",
			method : "POST",
			dataType : "json",
			data : {
				custId : id
			}
		}).done(function(r){
			var txt = "";
			$.each(r,function(index,value){
				txt += "<option value="+value['ProfileId']+">"+value['ProfileName']+"</option>"; 
			});
			$(that).parents(".form-group").siblings().find("#Profile").empty();
			$(that).parents(".form-group").siblings().find("#Profile").html(txt);
		}).fail(function(xhr,status){
			swal(status,"error");
		});
	});
	
	$("#type div").click(function(){
		var productType = $(this).attr("pid");
		var productGroupId = $(this).attr("gid");
		var type = $(this).attr("tid");
		//swal($(this).text());
		$.ajax({
			url : "Code/mylook.php?getMeasurementParameter",
			method : "POST",
			dataType : "json"
		}).done(function(r){
			var size = "";
			$.each(r['Size'],function(index,value){
				size += "<option pid='"+productType+"' value='"+value['MSizeId']+"'>"+value['SizeName']+"</option>"; 
			});
			
			
			var txt = "<tbody><tr><td><b>Parameter</b></td><td><b>Values</b></td><td></td></tr>";
			$.each(r['Parameter'],function(index,value){
				txt += "<tr>";
				txt += "<td id='"+value['MParameterId']+"'>"+value['MParameterName']+"</td>";
				txt += "<td><input type='number' step='.01' value='0' class='val'></td>"; 
				txt += "<td class='unit'><b>cm</b></td>";
				txt += "</tr>";
			});
			
			// txt += "<tr style='visibility:hidden'>";
			// txt += "<td><input  type='number' value='"+productType+"'  name='gid'></td>";
			// txt += "<td><input  type='number' value='"+productGroupId+"'  name='pid'></td>"; 
			// txt += "<td class='unit'><b>cm</b></td>";
			// txt += "</tr>";
			
			txt +="<tr><td colspan=2><b>Profile Name : </b><input id='profileName' type='text' value=''></td><td><div id='namecheck'></div></td></tr>";
			txt += "<tr><td><input type='button'  style='background-color:#999966' value='Back'></td>";
			txt += "<td><input id='profilesave' pid='"+productType+"' gid='"+productGroupId+"' tid='"+type+"' type='button'  style='background-color:#999966' value='Save'></td></tr></tbody>";
			
			
			$.featherlight($('#saveMeasurement'), {
				beforeOpen: function() { 
					$.featherlight.close(); 
				}
			});
			$(".featherlight #ms").empty().html(size);
			$(".featherlight").find("table").empty();
			$(".featherlight").find("table").html(txt);
			setTableButtonClickEvent();
			setSaveMeasurementClickEvent();
		}).fail(function(xhr,status){
			swal(status,"error");
		});
		
	});
}
function setSaveMeasurementClickEvent(){
	$(".featherlight #ms").off("change");
	$(".featherlight #mi").off("change");
	$(".featherlight #mi").change(function(){
		var value = $(this).find('option:selected').text();
		//console.log($(this).text());
		if(value.toLowerCase() == "centimeter" && !($(this).find('option:selected').hasClass('active'))){
			for(var i = 0 ; i < $(".featherlight .val").length ; i++){
				var cv = $(".featherlight .val").eq(i).val();
				$(".featherlight .val").eq(i).val(toCentimeter(cv));
			}
			$(".featherlight .unit").html("<b>cm</b>");
		}
		if(value.toLowerCase() == "inches" && !($(this).find('option:selected').hasClass('active'))){
			for(var i = 0 ; i < $(".featherlight .val").length ; i++){
				var cv = $(".featherlight .val").eq(i).val()
				$(".featherlight .val").eq(i).val(toInch(cv));
			}
			$(".featherlight .unit").html("<b>inch</b>");
		}
	});
	
	$(".featherlight #ms").change(function(){
		var value = $(this).find('option:selected').attr("value");
		var pid = $(this).find('option:selected').attr("pid");
		var gid = $(this).find('option:selected').attr("gid");
		var type = $(this).find('option:selected').attr("tid");
		var tag =  $(this).find('option:selected').attr("tag");
		var userProfileId =  $(this).find('option:selected').attr("upi");
		var profileName = $("#profileName").val();
		//console.log($(this).text());
		
		var parameters = new Object;
			for(var i = 0 ; i < $(".featherlight .val").length ; i++){
				parameters[$(".featherlight .val").eq(i).attr("pid")] = $(".featherlight .val").eq(i).val();
			}
		$.ajax({
			url : "Code/mylook.php?getSizeParameter",
			method : "POST",
			dataType : "json",
			data : {
				tid : type,
				sizeId : value
			}
		}).done(function(r){
			
			if(tag == "edit"){
				var txt = "<tbody><tr><td><b>Parameter</b></td><td><b>Values</b></td><td></td></tr>";
				// $.each(r['Parameter'],function(index,value){
					// txt += "<tr>";
					// txt += "<td id='"+value['MParameterId']+"'>"+value['MParameterName']+"</td>";
					// count = 0;
					// $.each(parameters,function(index2,value2){
						// if(index2 == value['MParameterId']){
							// txt += "<td><input IsAdded='false' type='number' class='val' value='"+value2+"'></td>";
							// count++;
						// }
					// });
					// if(count == 0)
						// txt += "<td><input IsAdded='true' type='number' value='0' class='val'></td>";
					// txt += "<td class='unit'><b>cm</b></td>";
					// txt += "</tr>";
				// });
				$.each(r['Parameter'],function(index,value){
					txt += "<tr>";
					txt += "<td id='"+value['MParameterId']+"'>"+value['MParameterName']+"</td>";
					txt += "<td><input  IsAdded='false' type='number' step='.01' value='"+value['MSizeValue']+"' class='val'></td>"; 
					txt += "<td class='unit'><b>cm</b></td>";
					txt += "</tr>";
				});
				
				// txt += "<tr style='visibility:hidden'>";
				// txt += "<td><input  type='number' value='"+productType+"'  name='gid'></td>";
				// txt += "<td><input  type='number' value='"+productGroupId+"'  name='pid'></td>"; 
				// txt += "<td class='unit'><b>cm</b></td>";
				// txt += "</tr>";
				
				txt +="<tr><td colspan=2><b>Profile Name : </b><input id='profileName' type='text' value='"+profileName+"'></td></tr>";
				txt += "<tr><td><input type='button'  style='background-color:#999966' value='Back'></td>";
				txt += "<td><input id='updateProfile' upi='"+userProfileId+"'  type='button'  style='background-color:#999966' value='Update'></td></tr></tbody>";
				
				
				// $.featherlight($('#saveMeasurement'), {
					// beforeOpen: function() { 
						// $.featherlight.close(); 
					// }
				// });
				//$(".featherlight #ms").empty().html(size);
				$(".featherlight").find("table").empty();
				$(".featherlight").find("table").html(txt);
				setTableButtonClickEvent();
				setSaveMeasurementClickEvent();
			}else{
				var txt = "<tbody><tr><td><b>Parameter</b></td><td><b>Values</b></td><td></td></tr>";
				$.each(r['Parameter'],function(index,value){
					txt += "<tr>";
					txt += "<td id='"+value['MParameterId']+"'>"+value['MParameterName']+"</td>";
					txt += "<td><input type='number' step='.01' value='"+value['MSizeValue']+"' class='val'></td>"; 
					txt += "<td class='unit'><b>cm</b></td>";
					txt += "</tr>";
				});
				
				// txt += "<tr style='visibility:hidden'>";
				// txt += "<td><input  type='number' value='"+productType+"'  name='gid'></td>";
				// txt += "<td><input  type='number' value='"+productGroupId+"'  name='pid'></td>"; 
				// txt += "<td class='unit'><b>cm</b></td>";
				// txt += "</tr>";
				
				txt +="<tr><td colspan=3><b>Profile Name : </b><input id='profileName' type='text' value=''><div style='color:red' id='namecheck'></div></td></tr>";
				txt += "<tr><td><input type='button'  style='background-color:#999966' value='Back'></td>";
				txt += "<td><input id='profilesave' pid='"+pid+"' gid='"+gid+"' tid='"+type+"' type='button'  style='background-color:#999966' value='Save'></td></tr></tbody>";
				
				
				// $.featherlight($('#saveMeasurement'), {
					// beforeOpen: function() { 
						// $.featherlight.close(); 
					// }
				// });
				//$(".featherlight #ms").empty().html(size);
				$(".featherlight").find("table").empty();
				$(".featherlight").find("table").html(txt);
				setTableButtonClickEvent();
				setSaveMeasurementClickEvent();
			}
			
		}).fail(function(xhr,status){
			swal(status,"error");
		});
		
	});
	
	$(".featherlight #profilesave").click(function(r){
	
		var ProfileName = $(".featherlight #profileName").val();
		if(ProfileName != ""){
			if(flag){
				var SaveProfile = [];
				var ProfileDetails = new Object();
				var Parameter = new Object();
				
				var productTypeId = $(this).attr("pid");
				var productGroupId = $(this).attr("gid");
				var measurementTypeId = $(this).attr("tid");
				
				//console.log("ProducTypeId : "+productTypeId + " ProductGroupId : "+productGroupId);
				ProfileDetails['ProductTypeId'] = productTypeId;
				ProfileDetails['ProductGroupId'] = productGroupId;
				
				
				//console.log("Profile Name : "+ProfileName);
				ProfileDetails['ProfileName'] = ProfileName;
				
				ProfileDetails['MeasurementSizeId'] = $(".featherlight #ms").find(":selected").attr("value");
				
				ProfileDetails['MeasurementSizeName'] = $(".featherlight #ms").find(":selected").html();
				
				ProfileDetails['MeasurementTypeId'] = measurementTypeId;
				SaveProfile.push(ProfileDetails);
				
				var count=0;
				for(var i=0; i < $(".featherlight .val").length ; i++)
				{
					if($(".featherlight .val").eq(i).val() == 0)
						continue;
					
					count++;
					if($(".featherlight #mi").find(":selected").text().toLowerCase() == "centimeter"){
						var o = new Object();
						o['ParameterId'] = $(".featherlight .val").eq(i).parent().siblings().attr("id");
						o['Value'] = $(".featherlight .val").eq(i).val();
						Parameter[$(".featherlight .val").eq(i).parent().siblings().html()] = o ;
					}
					else{
						var o = new Object();
						o['ParameterId'] = $(".featherlight .val").eq(i).parent().siblings().attr("id");
						o['Value'] = toCentimeter($(".featherlight .val").eq(i).val());
						Parameter[$(".featherlight .val").eq(i).parent().siblings().html()] = o ;
					}
					//console.log($(".featherlight .val").eq(i).parent().siblings().html()+" : "+$(".featherlight .val").eq(i).val());
				}
				
				SaveProfile.push(Parameter);
				//console.log(SaveProfile);
				
				if(count > 0){
					$.ajax({
					url : "Code/mylook.php?loginCheck",
					method : "POST",
					dataType : "json"
					}).done(function(r){
						if(r == "0" || r == 0){
							$.featherlight($('#login'), {
								beforeOpen: function() { 
									$.featherlight.close(); 
								}
							});
						}else{
							saveProfile(SaveProfile);
						}
					}).fail(function(xhr,status){
						swal({showCloseButton:true,title:"Oops...",text:status,type:"error"});
					});
				}else{
					swal({showCloseButton:true,title:"Oops...",text:"Please fill atleast one parameters",type:"error"});
				}
			}else{
				$(".featherlight").css("z-index","1059");
				swal({showCloseButton:true,title:"Oops...",text:"Profile name is already register",type:"error"});
			}
		}else{
				$(".featherlight").css("z-index","1059");
				swal({showCloseButton:true,title:"Oops...",text:"Profile name is empty",type:"error"});
		}
		
		
	});
	
	$(".featherlight #updateProfile").click(function(r){
		var SaveProfile = [];
		var ProfileDetails = new Object();
		var Parameter = new Object();
		
		var productTypeId = 0;
		var productGroupId = 0;
		var measurementTypeId = 0;
		//console.log("ProducTypeId : "+productTypeId + " ProductGroupId : "+productGroupId);
		ProfileDetails['ProductTypeId'] = productTypeId;
		ProfileDetails['ProductGroupId'] = productGroupId;
		
		var ProfileName = $("#profileName").val();
		//console.log("Profile Name : "+ProfileName);
		ProfileDetails['ProfileName'] = ProfileName;
		
		ProfileDetails['MeasurementSizeId'] = 0;
		ProfileDetails['MeasurementSizeName'] = $(".featherlight #ms").find(":selected").html();
		ProfileDetails['UserProfileId'] = $(this).attr("upi");
		
		ProfileDetails['MeasurementTypeId'] = measurementTypeId;
		SaveProfile.push(ProfileDetails);
		
		for(var i=0; i < $(".featherlight .val").length ; i++)
		{
			if($(".featherlight .val").eq(i).val() == 0)
				continue;
			
			if($(".featherlight #mi").find(":selected").text().toLowerCase() == "centimeter"){
				var o = new Object();
				o['ParameterId'] = $(".featherlight .val").eq(i).parent().siblings().attr("id");
				o['Value'] = $(".featherlight .val").eq(i).val();
				o['IsAdded'] = $(".featherlight .val").eq(i).attr("IsAdded");
				Parameter[$(".featherlight .val").eq(i).parent().siblings().html()] = o ;
			}
			else{
				var o = new Object();
				o['ParameterId'] = $(".featherlight .val").eq(i).parent().siblings().attr("id");
				o['Value'] = toCentimeter($(".featherlight .val").eq(i).val());
				o['IsAdded'] = $(".featherlight .val").eq(i).attr("IsAdded");
				Parameter[$(".featherlight .val").eq(i).parent().siblings().html()] = o ;
			}
			//console.log($(".featherlight .val").eq(i).parent().siblings().html()+" : "+$(".featherlight .val").eq(i).val());
		}
		SaveProfile.push(Parameter);
		//console.log(SaveProfile);
		
		$.ajax({
			url : "Code/mylook.php?loginCheck",
			method : "POST",
			dataType : "json"
			// data : {
				// profileData  : SaveProfile
			// }
		}).done(function(r){
			if(r == "0" || r == 0){
				$.featherlight($('#login'), {
					beforeOpen: function() { 
						$.featherlight.close(); 
					}
				});
			}else{
				updateProfile(SaveProfile);
			}
		}).fail(function(xhr,status){
			swal(status,"error");
		});
	});
}
function saveProfile(SaveProfile){
	$.ajax({
		url : "Code/mylook.php?saveProfile",
		method : "POST",
		dataType : "json",
		data : {
			profileData  : SaveProfile
		}
	}).done(function(r){
		//console.log(JSON.stringify(r));
		if(r == true || r == "true"){
			$.featherlight.close(); 
			swal({showCloseButton:true,title:'Congratulations...',text:'Your profile is save',type:'success'}).then(function(){
				openMesurement();
				$(".featherlight").css("z-index","1059");
			});
			
		}else{
			swal({showCloseButton:true,title:'Oops...',text:'Something Wrong..',type:'error'});
		}
			
	}).fail(function(xhr,status){
		swal(status,"error");
	});
}
function updateProfile(SaveProfile){
	$.ajax({
		url : "Code/mylook.php?updateProfile",
		method : "POST",
		dataType : "json",
		data : {
			profileData  : SaveProfile
		}
	}).done(function(r){
		//console.log(JSON.stringify(r));
		if(r == true || r == "true"){
			$.featherlight.close(); 
			swal({showCloseButton:true,title:'Congratulations...',text:'Your profile is save',type:'success'}).then(function(){
				openMesurement();
			});
		}else{
			swal({showCloseButton:true,title:'Oops...',text:'Something Wrong..',type:'error'}).then(function(){
				openMesurement();
			});
		}
			
	}).fail(function(xhr,status){
		swal(status,"error");
	});
}
function profileOpen(type){
		var productType = type['PTypeId'];
		var productGroupId = type['PGroupId'];
		var type = type['MTypeId'];
		//swal($(this).text());
		$.ajax({
			url : "Code/mylook.php?getMeasurementParameter",
			method : "POST",
			dataType : "json",
			data : {
				tid : type
			}
		}).done(function(r){
			var size = "";
			$.each(r['Size'],function(index,value){
				size += "<option gid='"+productGroupId+"' tid='"+type+"' pid='"+productType+"' value='"+value['MSizeId']+"'>"+value['SizeName']+"</option>"; 
			});
			
			
			var txt = "<tbody><tr><td><b>Parameter</b></td><td><b>Values</b></td><td></td></tr>";
			$.each(r['Parameter'],function(index,value){
				txt += "<tr>";
				txt += "<td id='"+value['MParameterId']+"'>"+value['MParameterName']+"</td>";
				txt += "<td><input type='number' step='.01' value='"+value['MSizeValue']+"' class='val'></td>"; 
				txt += "<td class='unit'><b>cm</b></td>";
				txt += "</tr>";
			});
		
			txt +="<tr><td colspan=3><b>Profile Name : </b><input id='profileName' type='text' value=''><div style='color:red' id='namecheck'></div></td></tr>";
			txt += "<tr><td><input type='button'  style='background-color:#999966' value='Back'></td>";
			txt += "<td><input id='profilesave' pid='"+productType+"' gid='"+productGroupId+"' tid='"+type+"' type='button'  style='background-color:#999966' value='Save'></td></tr></tbody>";
			
			
			$.featherlight($('#saveMeasurement'), {
				beforeOpen: function() { 
					$.featherlight.close(); 
				}
			});
			$(".featherlight #ms").empty().html(size);
			$(".featherlight").find("table").empty();
			$(".featherlight").find("table").html(txt);
			setTableButtonClickEvent();
			setSaveMeasurementClickEvent();
		}).fail(function(xhr,status){
			swal({showCloseButton:true,title:"Oops...",text:status,type:"error"});
		});
}

function openMesurement(){
  var url = $(location).attr('href'),
    		parts 	= url.split("/"),
    		product_handle = parts[parts.length-1].replace('#','');
     jQuery.getJSON('/products/'+product_handle+'.js', function(product) 
     {	
       		var output = [];
       		console.log(product);
			$("#measurement #product-description").html(product.description);
            $.each(product.variants, function(key, value)
            {
              output.push('<option data-sku="'+value.sku+'"  value="'+ value.id +'">'+ value.title+'</option>');
            });

            $("#measurement [name='id']").html(output.join(''));
     });
// 	$.ajax({
// 		url : "Code/mylook.php?getTypes",
// 		method : "POST",
// 		dataType : "json"
// 	}).done(function(r){
// 		type = r;
// 		var count=0;
// 		$.each(type,function(index,value){
// 				if(value['HexValue'].toLowerCase() == $("#Men .active").attr("hex").toLowerCase()){
// 					//swal(value['TypeName'].toLowerCase(),success);
// 					count++;
// 					PTypeId = value['PTypeId'];
// 					PGroupId = value['PGroupId'];
// 					MTypeId = value['MTypeId'];
// 				}
// 			});
// 			profile();
// 		//console.log(type);
// 	}).fail(function(xhr,status){
// 		swal(status,"error");
// 	});
}

function delProfile(ProfileId){
	//$("#measurement #Profile").find(":selected").val();
	$.ajax({
		url : "Code/mylook.php?deleteProfile",
		method : "POST",
		dataType : "json",
		data : {
			ProfileId : ProfileId
		}
	}).done(function(r){
		//consol.log(r);
		if(r['status'] == true){
			$.featherlight.close();
			swal({showCloseButton:true,title:"Thank You...",text:"Your Profile was Deleted",type:"success"}).then(function(){
				openMesurement();
				$(".featherlight").css("z-index","1059");
			});
		}
	}).fail(function(xhr,status){
		swal(status,"error");
	});
}

  //-------------//
 // * Utility * //
//-------------//

function toInch(n) {
  // var realFeet = ((n*0.393700) / 12);
  // var feet = realFeet;
  //var inches = (realFeet - feet) * 12;
  //return feet + "&prime;" + inches + '&Prime;';
  
  var inches = roundit(n/2.54);
  return inches;
}
function toCentimeter(n){
	//var cm = n * 2.54;
	var cm = roundit(n*2.54);
	return cm;
}
function isNumber(evt) {
	evt = (evt) ? evt : window.event;
	var charCode = (evt.which) ? evt.which : evt.keyCode;
	if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		return false;
	}
	return true;
}

function roundit(which){
	return Math.round(which*100)/100
}

function ValidateEmail(mail) 
{
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
  {
	return (true)
  }
	//alert("You have entered an invalid email address!")
	return (false)
}